import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import Popover from '../Popover/index.js';

/**
 * A component displaying supplied menu items within a wider popover with a constricted height.
 *
 */
import { jsx as _jsx } from "react/jsx-runtime";
function PopoverMenu(_ref) {
  let {
    className,
    ...rest
  } = _ref;
  const classes = clsx({
    'popover-menu': true
  }, className);
  return /*#__PURE__*/_jsx(Popover, {
    "data-cmp": "popoverMenu",
    className: classes,
    ...rest
  });
}
export default PopoverMenu;